module.exports = __webpack_public_path__ + "static/media/square_checkmark_active_yl.a1ef351d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square_checkmark_active_yl.svg
// module id = 13
// module chunks = 0